import { createSlice } from "@reduxjs/toolkit";
import { getItem, setItem } from "./utils/_idb_REPOSITORY";

export const RepositorySlice = createSlice({
    name: "Repository",
    initialState: {
        _fetched: false,
        items: [],
        autoSync: true,
    },
    reducers: {
        setFetched: (state, action) => {
            state._fetched = action.payload;
        },
        setRepositoryItems: (state, action) => {
            typeof window !== "undefined" && setItem("items", action.payload);
            state.items = action.payload;
        },
        setRepositoryAutoSync: (state, action) => {
            typeof window !== "undefined" && setItem("autoSync", action.payload);
            state.autoSync = action.payload;
        },
    },
});

export const { setFetched, setRepositoryItems, setRepositoryAutoSync } = RepositorySlice.actions;

export const getFetched = (state) => state.Repository._fetched;
export const getRepositoryItems = (state) => state.Repository.items;
export const getRepositoryAutoSync = (state) => state.Repository.autoSync;

export default RepositorySlice.reducer;

export const fetchRepositoryromIndexedDB = () => async (dispatch) => {
    try {
        if (typeof window !== "undefined") {
            await getItem("items").then((val) => dispatch(setRepositoryItems(val || [])));
            await getItem("autoSync").then((val) =>
                dispatch(setRepositoryAutoSync(val === undefined || val === null ? true : val))
            );

            return { fn: "fetchRepositoryromIndexedDB", error: false };
        }
    } catch (error) {
        return { fn: "fetchRepositoryromIndexedDB", error };
    }
};
export const clearRepositoryromIndexedDB = () => async (dispatch) => {
    try {
        if (typeof window !== "undefined") {
            await dispatch(setRepositoryItems([]));
            await dispatch(setRepositoryAutoSync(true));

            return { fn: "clearRepositoryromIndexedDB", error: false };
        }
    } catch (error) {
        return { fn: "clearRepositoryromIndexedDB", error };
    }
};
